import { render, staticRenderFns } from "./InReview.vue?vue&type=template&id=76ca6168&scoped=true&"
import script from "./InReview.vue?vue&type=script&lang=js&"
export * from "./InReview.vue?vue&type=script&lang=js&"
import style0 from "./InReview.vue?vue&type=style&index=0&id=76ca6168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca6168",
  null
  
)

export default component.exports